import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import Home from "../views/Home.vue";
import Berita from "../views/Berita.vue";
import Beritaisi from "../views/Beritaisi.vue";

import struktur_organisasi from "../views/Profile/struktur_organisasi.vue";
import data_pegawai from "../views/Profile/data_pegawai.vue";
import tentang from "../views/Profile/tentang.vue";
import tugas_pokok from "../views/Profile/tugas_pokok.vue";
import visi_misi from "../views/Profile/visi_misi.vue";


import sekretariat from "../views/UnitKerja/sekretariat.vue";
import bid_akutansi from "../views/UnitKerja/bid_akutansi.vue";
import bid_anggaran from "../views/UnitKerja/bid_anggaran.vue";
import bid_aset from "../views/UnitKerja/bid_aset.vue";
import bid_bud from "../views/UnitKerja/bid_bud.vue";


import perpres from "../views/Peraturan/perpres.vue";
import permen from "../views/Peraturan/permen.vue";
import perbup from "../views/Peraturan/perbup.vue";
import perda from "../views/Peraturan/perda.vue";

import pengelolaan_hbo from "../views/DataDokumen/pengelolaan_hbo.vue";
import sop from "../views/DataDokumen/sop.vue";
import transparansi_anggaran from "../views/DataDokumen/transparansi_anggaran.vue";
import dokumen_opd from "../views/DataDokumen/dokumen_opd..vue";

import gallery_foto from "../views/Galeri/gallery_foto.vue";
import gallery_video from "../views/Galeri/gallery_video.vue";

import realisasi_anggaran_2024 from "../views/Sipola/realisasi_anggaran_2024.vue";
import realisasi_anggaran_2025 from "../views/Sipola/realisasi_anggaran_2025.vue";
import realisasi_anggaran_2026 from "../views/Sipola/realisasi_anggaran_2026.vue";
import realisasi_pad_2024 from "../views/Sipola/realisasi_pad_2024.vue";
import realisasi_pad_2025 from "../views/Sipola/realisasi_pad_2025.vue";
import realisasi_pad_2026 from "../views/Sipola/realisasi_pad_2026.vue";




const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/Berita',
    name: 'Berita',
    component: Berita
  },
  {
    path: '/Beritaisi/:id',
    name: 'Beritaisi',
    component: Beritaisi
  },


  // PROFILE
  {
    path: '/struktur_organisasi',
    name: 'Struktur Organisasi',
    component: struktur_organisasi
  }, 
  {
    path: '/data_pegawai',
    name: 'Data Pegawai',
    component: data_pegawai
  }, 
  {
    path: '/tentang',
    name: 'Tentang',
    component: tentang
  }, 
  {
    path: '/tugas_pokok',
    name: 'Tugas Pokok',
    component: tugas_pokok
  }, 
  {
    path: '/visi_misi',
    name: 'Visi Misi',
    component: visi_misi
  }, 
  // UNIT KERJA 
  {
    path: '/sekretariat',
    name: 'Sekretariat',
    component: sekretariat
  }, 
  {
    path: '/bid_akutansi',
    name: 'Bidang Akutansi',
    component: bid_akutansi
  }, 
  {
    path: '/bid_anggaran',
    name: 'Bidang Anggaran',
    component: bid_anggaran
  }, 
  {
    path: '/bid_aset',
    name: 'Bidang Aset',
    component: bid_aset
  }, 
  {
    path: '/bid_bud',
    name: 'Bidang BUD',
    component: bid_bud
  }, 
  // PERATURAN
  {
    path: '/perpres',
    name: 'Peraturan Presiden',
    component: perpres
  }, 
  {
    path: '/permen',
    name: 'Peraturan Mentri',
    component: permen
  }, 
  {
    path: '/perbup',
    name: 'Peraturan Bupati',
    component: perbup
  }, 
  {
    path: '/perda',
    name: 'Peraturan Daerah',
    component: perda
  }, 
  // DATA & DOKUMEN
  {
    path: '/pengelolaan_hbo',
    name: 'Pengelolaan Hibah Bansos Online',
    component: pengelolaan_hbo
  }, 
  {
    path: '/sop',
    name: 'Standar Operasional Prosedur',
    component: sop
  }, 
  {
    path: '/transparansi_anggaran',
    name: 'Transparansi Anggaran Daerah',
    component: transparansi_anggaran
  }, 
  {
    path: '/dokumen_opd',
    name: 'Dokumen Lainnya',
    component: dokumen_opd
  }, 
  // GALERI
  {
    path: '/gallery_foto',
    name: 'Foto',
    component: gallery_foto
  }, 
  {
    path: '/gallery_video',
    name: 'Video',
    component: gallery_video
  }, 
  // SIPOLA 
  {
    path: '/realisasi_anggaran_2024',
    name: 'Realisasi Belanja OPD Tahun 2024',
    component: realisasi_anggaran_2024
  }, 
  {
    path: '/realisasi_anggaran_2025',
    name: 'Realisasi Belanja OPD Tahun 2025',
    component: realisasi_anggaran_2025
  }, 
  {
    path: '/realisasi_anggaran_2026',
    name: 'Realisasi Belanja OPD Tahun 2026',
    component: realisasi_anggaran_2026
  },
  {
    path: '/realisasi_pad_2024',
    name: 'Realisasi PAD OPD Tahun 2024',
    component: realisasi_pad_2024
  }, 
  {
    path: '/realisasi_pad_2025',
    name: 'Realisasi PAD OPD Tahun 2025',
    component: realisasi_pad_2025
  }, 
  {
    path: '/realisasi_pad_2026',
    name: 'Realisasi PAD OPD Tahun 2026',
    component: realisasi_pad_2026
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
